// 不同项目 一些差异性功能的描述 用于区分配置
/**
 * 描述
 * @param {String} name 域名关键字
 * @param {Boolean} preload 是否需要开启预加载
 * @param {Array} preloadPort 需要预加载的子项目端口
 * @param {Boolean} watermark 是否开启水印
 * @param {object} businessHeader header部分的一些模块
    * header部分定义
    * Knowledge：平台知识库
    * Msg: 消息
    * Work: 上下班
    * TenantSwitch：切换租户
    * CallBox：外呼
  @param {Array}  外部项目 差异性接口 废弃 三期统一
  @param {Boolean} redirect 是否开启链接重定向跳转
  @param {String} defaultHomePage 登录后默认跳转的页面 路由
  @param {String} appId 系统对应的id
  @param {object} imagesObj 图片资源
  @param {Array} loginDefine 登录集合的定义
    * name tab名称
    * component 组件名称
    *   - UserNameLogin 账号登录
    *   - VerificationLogin 手机号登录
    *   - AccountLogin 域账号登录
 */
// eslint-disable-next-line no-unused-vars
const domainNamDsl = [
  {
    name: 'diting',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10013',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'paladin',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader: {},
    redirect: false,
    defaultHomePage: '',
    appId: '10011',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'gyl',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '20001',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'logistics',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '20008',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'cmhub',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10025',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'CmhubLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'boss',
    preload: false,
    preloadPort: [],
    watermark: true,
    businessHeader:
    {
      CallBox: 'right',
      Knowledge: 'right',
      Work: 'right',
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10004',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'crm',
    preload: false,
    preloadPort: [],
    watermark: true,
    businessHeader: {},
    redirect: false,
    defaultHomePage: '',
    appId: '10007',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'sh',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader: {
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10009',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'farm',
    preload: true,
    preloadPort: ['5000', '3091', '3092'],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '90001',
    imagesObj: {
      // eslint-disable-next-line global-require
      home: require('@/assets/images/homepic.png'),
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'xirang',
    preload: true,
    preloadPort: ['5000', '3091', '3092'],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '90001',
    imagesObj: {
      // eslint-disable-next-line global-require
      home: require('@/assets/images/homepic.png'),
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'ccs',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader: {},
    redirect: false,
    defaultHomePage: '',
    appId: '10015',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'skydome',
    preload: true,
    preloadPort: ['3092', '4000'],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10016',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'saas',
    preload: true,
    preloadPort: ['3092', '4000'],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10016',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'ynjt',
    preload: true,
    preloadPort: ['3092', '4000'],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10016',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'finance',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10019',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'themis',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader: {},
    redirect: false,
    defaultHomePage: '',
    appId: '10020',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'tboss',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '20001',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'tms',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '20001',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'bigdata',
    preload: true,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10022',
    imagesObj: {},
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'console',
    preload: true,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '10023',
    imagesObj: {},
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'workflow',
    preload: true,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '99999',
    imagesObj: {},
    loginDefine: [
      {
        name: '域账号登录',
        component: 'AccountLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'investor',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '20004',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
  {
    name: 'supplier',
    preload: false,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '20030',
    imagesObj: {
      home: '',
    },
    loginDefine: [
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: ['ForgetPassword', 'ChangingPassword'],
  },
];

export {
  // eslint-disable-next-line import/prefer-default-export
  domainNamDsl,
};
